export default {
    grantUserState: {
        Novy: "Nový",
        OdesilaniNotifikace: "Odesílání notifikace",
        Odeslano: "Odesláno",
        Vyjadreno: "Vyjádřeno",
        Zruseno: "Zrušeno",
        Dokonceno: "Dokončeno",
        Notifikovano: "Notifikováno",
        Prijato: "Přijato",
        Probiha: "Probíhá",
        Zamitnuto: "Zamítnuto",
    },

    pozadavekStav: {
        Prijato: "Čeká na zpracování",
        ProbihaZpracovani: "Probíhá zpracování",
        Zpracovano: "Zpracováno",
        Chyba: "Chyba",
        Zruseno: "Zrušeno",
    },

    pozadavekIsDtmkStav: {
        CekaNaOdeslani: "Čeká na zpracování",
        PrijatoKrajem: "Probíhá zpracování",
        Zpracovano: "GAD zapracovatelná",
        ZpracovanoSChybami: "GAD nezapracovatelná",
        Chyba: "Chyba",
        ProbihaZpracovani: "Probíhá zpracování",
    },

    registry: {
        registrSubjektuEvidenceDti: "Registr VSP a editorů DTI",
        registrEditoruZps: "Registr editorů ZPS",
        registrUozi: "Registr AZI",
        registrOpravnenychZadatelu: "Registr žadatelů",
        registrIsDtmk: "Registr IS DTMK",
        registrBudoucichStavebniku: "Registr budoucích stavebníků",
    },

    obsahDat: {
        zpsKresba: "Data základní prostorové situace - kresba",
        zpsPodrobneBody: "Data základní prostorové situace - podrobné body",
        zpsOdvozenePlosneTypyObjektu: "Data základní prostorové situace - odvozené plošné typy objektů",
        zpsDoprovodneInformace: "Data základní prostorové situace - doprovodné informace",
        zps: "Data základní prostorové situace",
        di: "Data dopravní infrastruktury",
        ti: "Data technické infrastruktury",
    },

    obsahDatVerejnaVydej: {
        zpsKresba: "ZPS (data základní prostorové situace) - kresba",
        zpsPodrobneBody: "ZPS (data základní prostorové situace) - podrobné body",
        zpsOdvozenePlosneTypyObjektu: "ZPS (data základní prostorové situace) - odvozené plošné typy objektů",
        zpsDoprovodneInformace: "ZPS (data základní prostorové situace) - doprovodné informace",
        di: "DI (veřejná data dopravní infrastruktury)",
    },

    obsahDatVerejnaVyhotoveni: {
        zps: "ZPS (data základní prostorové situace)",
        di: "DI (veřejná data dopravní infrastruktury)",
    },

    obsahDatNeverejna: {
        di: "DI (veřejná i neveřejná data dopravní infrastruktury)",
        ti: "TI (veřejná i neveřejná data technické infrastruktury)",
    },

    dostupnostDat: {
        verejna: "Veřejná data",
        neverejna: "Neveřejná data",
    },

    typDat: {
        stavova: "Stavová data",
        zmenova: "Změnová data",
    },

    typDatVydejPsp: {
        Kompletni: "Kompletní data",
        VerejneFinance: "Data PSP financovaných z veřejných zdrojů",
    },

    vydejDatStav: {
        Prijato: "Čeká na zpracování",
        CekaNaOdeslani: "Čeká na zpracování",
        ProbihaZpracovani: "Probíhá zpracování",
        PrijatoKrajem: "Probíhá zpracování",
        Zpracovano: "Zpracováno",
        Chyba: "Chyba",
        Zruseno: "Zrušeno",
    },

    typPodaniGad: {
        KontrolniZaslani: "Kontrolní zaslání dat",
        GeodetickaAktualizacniDokumentace: "Požadavek na změnu",
        PozadavekNaZapracovaniGad: "Požadavek na zpracování GAD",
        AktualizacniDokumentace: "Požadavek na změnu",
    },

    vysledekPodaniGad: {
        GadZapracovatelna: "Zapracovatelná GAD",
        GadNezapracovatelna: "Nezapracovatelná GAD",
    },

    vysledekPodaniGadFilter: {
        Zapracovatelna: "GAD zapracovatelná",
        Nezapracovatelna: "GAD nezapracovatelná",
    },

    typPozadavku: {
        PozadavekNaVydejNeverejnychZmenovychDatovychSad: "Výdej neveřejných změnových datových sad",
        PozadavekNaVydejNeverejnychStavovychDatovychSad: "Výdej neveřejných stavových datových sad",
        PozadavekNaVyhotoveniNeverejneDatoveSady: "Vyhotovení neveřejné datové sady",
        PozadavekNaVyhotoveniVerejneDatoveSady: "Vyhotovení veřejné datové sady",
        PozadavekNaVydejVlastnichDatVsp: "Výdej vlastních dat VSP",
    },

    typPozadavkuPsp: {
        PozadavekNaVydejVlastnichDatPspi: "Výdej vlastních dat PSP",
        PozadavekNaVyhotoveniDatoveSadyPspi: "Výdej dat PSP v definovaném území",
        PozadavekNaVydejObsahuPspi: "Výdej obsahu PSP",
    },

    typZadosti: {
        "vydej-zmenovych-datovych-sad": "Žádost o výdej neveřejných změnových datových sad",
        "vydej-stavovych-datovych-sad": "Žádost o výdej neveřejných stavových datových sad",
        "vyhotoveni-neverejne-datove-sady": "Žádost o vyhotovení neveřejné datové sady",
        "vyhotoveni-verejne-datove-sady": "Žádost o vyhotovení veřejné datové sady",
        "vydej-vlastnich-dat": "Žádost o výdej vlastních dat VSP",
    },

    typZadostiPsp: {
        "vyhotoveni-datove-sady-psp": "Žádost o výdej dat PSP v definovaném území",
        "vydej-obsahu-psp": "Žádost o výdej obsahu PSP",
    },

    typHlaseniGad: {
        Informace: "Informace",
        Varovani: "Varování",
        Chyba: "Chyba",
    },

    typPozadavkuValidace: {
        PozadavekNaValidaciJvf: "Požadavek na validaci JVF",
    },

    validaceDatVysledek: {
        Validni: "Validní",
        Nevalidni: "Nevalidní",
    },

    validaceDatZaznam: {
        Informace: "Informace",
        Chyba: "Chyba",
        Varovani: "Varování",
    },

    stavIsDtmk: {
        Chyba: "Nedostupný",
        Odstavka: "Odstávka",
        Provoz: "Dostupný",
    },

    stavPozadavkuNaRegistraciSubjektu: {
        CekaNaVyjadreni: "Čeká na vyjádření",
        Novy: "Nový",
        Uzavreno: "Uzavřeno",
        Vyjadreno: "Vyjádřeno",
        Notifikovano: "Notifikováno",
        OdesilaniNotifikace: "Odesílání notifikace",
        Schvaleno: "Schváleno",
        Zamitnuto: "Zamítnuto",
        Zruseno: "Zrušeno",
    },

    psp: {
        aktualniPocetPriloh1: "U plánované stavby je již nahráno | U plánované stavby je již nahrána | U plánované stavby jsou již nahrány | U plánované stavby je již nahráno",
        aktualniPocetPriloh2: "příloh. | příloha. | přílohy. | příloh.",
    },

    stavZadostiZjisteniUzemi: {
        Prijato: "Čeká na zpracování",
        ProbihaZpracovani: "Probíhá zpracování",
        Zpracovano: "Zpracováno",
        Chyba: "Chyba",
        Zruseno: "Zrušeno",
    },

    zjisteniUzemiSpravcu: {
        aktualniPocetParcel1: "Aktuálně máte vybráno | Aktuálně máte vybránu | Aktuálně máte vybrány | Aktuálně máte vybráno",
        aktualniPocetParcel2: "parcel. | parcelu. | parcely. | parcel.",
        zpusobDefiniceUzemi: {
            polygon: "Zakreslením polygonu",
            parcely: "Výběrem parcel",
        },
    },

    editaceObsahuPspStav: {
        Prijato: "Čeká na zpracování",
        ProbihaZpracovani: "Probíhá zpracování",
        Zpracovano: "Zpracováno",
        Chyba: "Chyba",
        Zruseno: "Zrušeno",
    },

    editaceObsahuPspVysledek: {
        EditaceProvedena: "Editace provedena",
        EditaceZamitnuta: "Editace zamítnuta",
    },

    editaceObsahuPspVysledekPopis: {
        EditaceProvedena: "Editace provedena.",
        EditaceZamitnuta: "Editace zamítnuta (nevalidní obsah).",
    },

    statusZadateleTexts: {
        VlastnikSpravceProvozovatel: {
            text: "Status je určen vlastníkům, správcům a provozovatelům dopravní a technické infrastruktury. Data DTM mohou využívat pouze v rozsahu nezbytném pro zajištění provozu, údržby, obnovy a rozvoje této infrastruktury. Pro využití statusu musí být subjektu udělena verifikace pro výdej neveřejných dat."
        },
        ZadatelDleZadosti: {
            text: "Status je určen subjektům, které žádají o poskytnutí dat na základě konkrétní žádosti a uvedeného účelu jejich použití.",
            text2: "Při podání žádosti je povinné přiložit odůvodnění požadavku, které je systémem evidováno a slouží jako podklad pro posouzení oprávněnosti výdeje dat. Oprávněnost výdeje dat posuzuje správce krajské DTM. Rozsah poskytovaných dat je omezen výhradně na území a obsah nezbytný k naplnění účelu žádosti."
        },
        OrganVerejneMoci: {
            text: "Status je určen vybraným orgánům veřejné moci. Data DTM mohou využívat pouze v rozsahu nezbytném pro plnění úkolů při výkonu jejich působnosti."
        },
        VlastnikDotcenychNemovitosti: {
            text: "Status je určen pro žadatele v území, ve kterém vlastní nemovitost (pozemek nebo stavbu). Systém po odeslání žádosti automaticky ověří vlastnictví v katastru nemovitostí. Data budou poskytnuta, pouze pokud bude potvrzeno vlastnictví v celém území uvedeném v žádosti."
        },
        Azi: {
            text: "Status je určen osobám oprávněným ověřovat výsledky zeměměřických činností dle § 16f, odst. 1, písm. c) zákona o zeměměřictví. Data jsou poskytována v rozsahu nezbytném pro tuto činnost."
        },
    },

    statusZadatelePspiTexts: {
        VlastnikSpravceProvozovatel: {
            text: "Status je určen vlastníkům, správcům a provozovatelům dopravní a technické infrastruktury. Data PSPI mohou využívat pouze v rozsahu nezbytném pro zajištění provozu, údržby, obnovy a rozvoje této infrastruktury. Pro využití statusu musí být subjektu udělena verifikace pro výdej neveřejných dat."
        },
        ZadatelDleZadosti: {
            text: "Status je určen subjektům, které žádají o poskytnutí dat na základě konkrétní žádosti a uvedeného účelu jejich použití.",
            text2: "Při podání žádosti je povinné přiložit odůvodnění požadavku, které je systémem evidováno a slouží jako podklad pro posouzení oprávněnosti výdeje dat. Oprávněnost výdeje dat posuzuje správce krajské DTM. Rozsah poskytovaných dat je omezen výhradně na území a obsah nezbytný k naplnění účelu žádosti."
        },
        OrganVerejneMoci: {
            text: "Status je určen vybraným orgánům veřejné moci. Data PSPI mohou využívat pouze v rozsahu nezbytném pro plnění úkolů při výkonu jejich působnosti."
        },
        VlastnikDotcenychNemovitosti: {
            text: "Status je určen pro žadatele v území, ve kterém vlastní nemovitost (pozemek nebo stavbu). Systém po odeslání žádosti automaticky ověří vlastnictví v katastru nemovitostí. Data budou poskytnuta, pouze pokud bude potvrzeno vlastnictví v celém území uvedeném v žádosti."
        },
        Azi: {
            text: "Status je určen osobám oprávněným ověřovat výsledky zeměměřických činností dle § 16f, odst. 1, písm. c) zákona o zeměměřictví. Data jsou poskytována v rozsahu nezbytném pro tuto činnost."
        },
    },

    neplatnaVerifikace: {
        neverifikovan: "Uvedený subjekt není verifikovaným VSP dle § 4b odst. 10 písm. c) zákona o zeměměřictví oprávněným pro výdej neveřejných dat. Žádost o výdej neveřejných dat za tento subjekt je možné zaslat se statusem \"Žadatel prokazující se žádostí (projektant, zpracovatel ÚAP)\". Pro použití tohoto statusu je potřebná registrace do registru žadatelů IS DMVS a při podání žádosti o výdej dat je nutné prokázat splnění zákonných podmínek.",
        verifikaceZrusena: {
            text1: "Uvedený subjekt není verifikovaným VSP oprávněným pro výdej neveřejných dat. Jeho oprávnění bylo zrušeno správcem IS DMVS. Pro obnovu oprávnění kontaktujte správce IS DMVS (",
            adresa: "DMVS.spravce{'@'}cuzk.gov.cz",
            text2: "). Žádost o výdej neveřejných dat za tento subjekt je možné zaslat se statusem \"Žadatel prokazující se žádostí (projektant, zpracovatel ÚAP)\". Pro použití tohoto statusu je potřebná registrace do registru žadatelů IS DMVS a při podání žádosti o výdej dat je nutné prokázat splnění zákonných podmínek.",
        },
    },

    neplatnaVerifikaceDatoveSadyPsp: {
        neverifikovan: "Uvedený subjekt není verifikovaným VSP dle § 4b odst. 10 písm. c) zákona o zeměměřictví oprávněným pro výdej neveřejných dat plánovaných stavebních prací infrastruktury. Žádost o výdej neveřejných dat za tento subjekt je možné zaslat se statusem \"Žadatel prokazující se žádostí (projektant, zpracovatel ÚAP)\" prostřednictvím služby Výdej dat PSP v definovaném území. Pro použití tohoto statusu je potřebná registrace do registru žadatelů IS DMVS a při podání žádosti o výdej dat je nutné prokázat splnění zákonných podmínek.",
        verifikaceZrusena: {
            text1: "Uvedený subjekt není verifikovaným VSP oprávněným pro výdej neveřejných dat plánovaných stavebních prací infrastruktury. Jeho oprávnění bylo zrušeno správcem IS DMVS. Pro obnovu oprávnění kontaktujte správce IS DMVS (",
            adresa: "DMVS.spravce{'@'}cuzk.gov.cz",
            text2: "). Žádost o výdej neveřejných dat za tento subjekt je možné zaslat se statusem \"Žadatel prokazující se žádostí (projektant, zpracovatel ÚAP)\" prostřednictvím služby Výdej dat PSP v definovaném území. Pro použití tohoto statusu je potřebná registrace do registru žadatelů IS DMVS a při podání žádosti o výdej dat je nutné prokázat splnění zákonných podmínek.",
        },
    },

    typUlohyDtmk: {
        VyhotoveniDatoveSadyPspiSchvaleniIsDtmk: "Vyjádření k žádosti o výdej dat PSPI v definovaném území",
    },

    typUlohyDtmkUrl: {
        "vyjadreni-zadosti-vyhotoveni-dat-pspi": "Vyjádření k žádosti o výdej dat PSPI v definovaném území",
    },

    vysledekUlohyDtmk: {
        Zamitnuto: "Zamítnuto",
        Schvaleno: "Schváleno",
        Zruseno: "Zrušeno",
        Novy: "Čeká na vyjádření",
        Notifikovano: "Čeká na vyjádření",
        OdesilaniNotifikace: "Čeká na vyjádření",
    },
};
